import React, {useEffect} from 'react';
import {t} from '@lingui/core/macro';

import {IPayment, paymentAPI, PaymentStatus} from 'entities/payment';

import Box from '../../../shared/ui/Box/Box';

import LinkButton from '../../../shared/ui/Button/LinkButton/LinkButton';
import {AppUrls} from '../../../shared/config/model/urls';

import styles from './Payments.module.scss';

interface IPaymentCancelProps {
    item: IPayment
}

const PaymentCancel: React.FC<IPaymentCancelProps> = ({item}) => {
    const [updatePayment] = paymentAPI.useUpdatePaymentMutation();
    useEffect(() => {
        updatePayment({
            id: item.id,
            status: PaymentStatus.Canceled,
        });
    }, [item.id, updatePayment]);
    return (
        <div className={styles.wrapper}>
            <div className={styles.box_wrapper}>
                <Box>
                    <div className="row text-center mb-3">
                        <div className="col-12">
                            <h2 className="mb-3">{t`Отмена платежа`}</h2>
                            <div className={styles.text}>
                                {`${t`Оплата тарифа`} "${item.tariff.name}" ${t`отменена`}`}
                            </div>
                        </div>
                    </div>

                    <LinkButton
                        href={AppUrls.PAYMENTS}
                        primary
                        block
                    >
                        {t`Продолжить`}
                    </LinkButton>
                </Box>
            </div>
        </div>
    );
};

export default PaymentCancel;